<template>
  <div>
    <table style="border-collapse:collapse;">
      <tr>
        <td class="col-md-12 text-left" width="100%">
          <img :src="require('@/shared/assets/images/left.jpg')" alt />
        </td>
        <td class="col-6-md text-right">
          <img :src="require('@/shared/assets/images/3F_transport.png')" alt/>
        </td>
      </tr>
    </table>

    <h1>{{ $t('contract.header.headline') }}</h1>
    <p v-show="displayDisclaimer">{{ $t('contract.header.disclaimer') }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    displayDisclaimer() {
      let locale = this.$store.state.contract.locale.contractLanguage;
      return locale !== "da-DK";
    }
  }
};
</script>
